import { AppRoutePath } from 'Pages/routes';
import BrowseServiceProvidersPageLayout from 'Common/components/BrowseServiceProvidersPageLayout';
import ServiceProviderSelect from 'Common/components/ServiceProviderSelect';
import ServiceProviderListItem from 'Common/components/ServiceProviderListItem';
import { GetUserWithLocations } from 'Common/functions/getUserWithLocations';
import { QueryServiceProviders } from 'Common/functions/guestQueryServiceProviders';
import { AppCookie, setCookie } from 'Common/functions/Cookie';
import { ConfigProvider } from 'antd';
import { AntdConfigProviderTheme } from 'Common/functions/antdTheme';
import BrowseServiceProviderBreadcrumbs from '../BrowseServiceProviderBreadcrumbs';
import NavigationWithLocationSelect from '../NavigationWithLocationSelect';
import { offPlatformServiceProviders } from 'Common/functions/OffPlatformServiceProviders';
import { GetRequestAppointmentUrlV3 } from '../ServiceProviderListItem/fn';

type BrowseServiceProvidersPageContentProps = {
  serviceProviders: QueryServiceProviders;
  offPlatformServiceProviders?: offPlatformServiceProviders;
  locations: GetUserWithLocations['locations']
  isTemporaryUser: boolean;
  serviceType: string;
  setSelectedLocationId: (id: string) => void;
  refetchLocations: () => Promise<void>;
  selectedLocationId: string | undefined;
  hideSelectButton?: boolean;
  isLoading?: boolean;
  breadcrumbTitle?: string;
}

const BrowseServiceProvidersPageContent: React.FC<BrowseServiceProvidersPageContentProps> = ({
  serviceProviders,
  offPlatformServiceProviders,
  locations,
  isTemporaryUser,
  serviceType,
  setSelectedLocationId,
  refetchLocations,
  selectedLocationId,
  hideSelectButton,
  isLoading = false,
  breadcrumbTitle,
}) => {
  const navigation = (
    <NavigationWithLocationSelect
      value={selectedLocationId}
      locations={locations}
      isTemporaryUser={isTemporaryUser}
      onSelect={id => {
        setSelectedLocationId(id);
        setCookie(AppCookie.CustomerSelectedLocationId, id, 14);
      }}
      onUpdate={() => {
        refetchLocations();
      }}
    >
      <BrowseServiceProviderBreadcrumbs
        serviceType={serviceType}
        innerClass="sm:w-full md:w-4/5 sm:px-4 lg:px-0"
        title={breadcrumbTitle}
      />
    </NavigationWithLocationSelect>
  );

  return (
    <div className="min-h-screen flex flex-col justify-between">
      <BrowseServiceProvidersPageLayout
        navigation={navigation}
      >
        <ConfigProvider theme={AntdConfigProviderTheme}>
          <div className="flex flex-col gap-4">
            {serviceProviders && (
              <ServiceProviderSelect
                serviceProviders={serviceProviders}
                isLoading={isLoading}
                hideEmpty={Boolean(offPlatformServiceProviders?.length)}
                renderItem={sp => {
                  const spDetailPage = AppRoutePath.SP
                    .replace('[serviceProviderSlug]', sp.slug);

                  return (
                    <ServiceProviderListItem
                      serviceProvider={sp}
                      link={spDetailPage}
                      hideSelectButton={hideSelectButton}
                      getSelectedServiceOfferingLink={selectedOfferingUid => GetRequestAppointmentUrlV3(
                        sp.user.id,
                        selectedOfferingUid,
                      )}
                      phoneNumber={sp.location.phoneNumber}
                    />
                  );
                }}
              />
            )}
            {offPlatformServiceProviders && (
              <ServiceProviderSelect
                serviceProviders={offPlatformServiceProviders.map(
                  sp => sp.serviceProvider
                )}
                isLoading={isLoading}
                renderItem={sp => {
                  const spDetailPage = AppRoutePath.LOCAL_SP
                    .replace('[serviceProviderSlug]', sp.slug);

                  return (
                    <ServiceProviderListItem
                      serviceProvider={sp}
                      link={spDetailPage}
                      hideSelectButton={hideSelectButton}
                      phoneNumber={sp.phoneNumber}
                      getSelectedServiceOfferingLink={() => ''}
                    />
                  );
                }}
                hideEmpty={true}
              />
            )}
          </div>
        </ConfigProvider>
      </BrowseServiceProvidersPageLayout>
    </div>
  );
};

export default BrowseServiceProvidersPageContent;

